const volunteers = state => state.volunteers
const pendingVolunteers = state => state.pendingVolunteers
const volunteer = state => state.volunteer

export default {
  volunteers,
  pendingVolunteers,
  volunteer
};
